
// this file is automatically generated by bin/write-version-env.ts script
export const versions = {
  version: '5.0.4',
  revision: '6edca1b',
  branch: 'develop',
};
